export const vehicleDeviceStatus = [
  { id: 1, name: "All", value: "all" },
  { id: 2, name: "Deleted", value: "deleted" },
  { id: 3, name: "Operational", value: "operational" },
  { id: 4, name: "Inactive", value: "inactive" },
  { id: 5, name: "Breakdown", value: "breakdown" },
  { id: 6, name: "Maintenance", value: "maintenance" },
  { id: 7, name: "Device Stolen", value: "device_stolen" },
  { id: 8, name: "Device Damaged", value: "device_damaged" },
  { id: 9, name: "Tampered Connection", value: "tampered_connection" },
  {
    id: 10,
    name: "Veh not av Device In Veh",
    value: "veh_not_av_device_in_veh",
  },
  { id: 11, name: "To be checked", value: "to_be_checked" },
  { id: 12, name: "Non Operational", value: "non_operational" },
  { id: 13, name: "Device Removed", value: "device_removed" },
  { id: 14, name: "IS NULL", value: "is_null" },
  { id: 15, name: "IS NOT NULL", value: "is_not_null" },
];

export const gpsStatus = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Deleted",
    value: "deleted",
  },
  {
    name: "Inactive",
    value: "inactive",
  },
  {
    name: "Gps Installed",
    value: "installed",
  },
  {
    name: "Gps Installations Pending",
    value: "pending",
  },
];
export const runningStatus = [
  {
    name: "RUNNING",
    value: "RUNNING",
  },
  {
    name: "HALT",
    value: "HALT",
  },
  {
    name: "STOP",
    value: "STOP",
  },
  {
    name: "OFFLINE",
    value: "OFFLINE",
  },
];
export const TrackingList = [
  {
    name: "TRACKING",
    id: true,
  },
  {
    name: "NOT TRACKING",
    id: false,
  },
];
export const powerCutStataus = [
  {
    name: "Out Of Network",
    id: false,
  },
  {
    name: "Power Cut",
    id: false,
  },
];
export const loadStatus = [
  {
    name: "LOADED",
    id: "IN_PROGRESS",
  },
  {
    name: "UNLOADED",
    id: "COMPLETED",
  },
];

export const OrganisationList = [
  { name: "BASUNDHARA" },
  { name: "IB VALLEY" },
  { name: "LBL" },
  { name: "BHARATPUR" },
  { name: "BHUBNESWARI" },
  { name: "HINGULA" },
  { name: "JAGANNATH" },
  { name: "KANIHA" },
  { name: "LINGARAJ" },
  { name: "ORIENT" },
  { name: "TALCHER" },
  { name: "SURFACE MINER" },
];
